@if (notificationsFeatureEnabled) {
<div class="notification-bell-container">
  <!-- Bell Icon -->
  <button
    type="button"
    class="bell-button"
    (click)="togglePanel($event)"
    [attr.aria-label]="translationService.translate('notificationsText')"
    id="notification-bell"
  >
    <mat-icon>notifications</mat-icon>
    <!-- Badge -->
    @if ((unreadCount$ | async); as count) { @if (count > 0) {
    <span class="badge" id="notification-badge">{{ displayCount }}</span>
    } }
  </button>

  <!-- Notification Panel -->
  @if (isPanelOpen) {
  <div class="notification-panel" #notificationPanel id="notification-panel" (click)="$event.stopPropagation()">
    <div class="panel-header">
      <h3>{{ translationService.translate('notificationsText') }}</h3>
      <div class="panel-header-actions">
        @if (hasNotifications) {
        <button type="button" class="dismiss-all-link" (click)="dismissAll()">
          {{ translationService.translate('dismissText') }}
          {{ translationService.translate('allText') }}
        </button>
        }
        <button type="button" class="close-button" (click)="closePanel()" [attr.aria-label]="translationService.translate('closeText')">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="panel-content" [ngClass]="{ scrollable: isScrollable }">
      @if (hasNotifications) {
      <div class="notifications-list">
        @for (notif of displayedNotifications; track notif.notificationId) {
        <div class="notification-item" [ngClass]="{ unread: !notif.isSeen }" id="notification-{{ notif.notificationId }}">
          <div class="notification-icon">
            <mat-icon>{{ getIconForAction(notif.action) }}</mat-icon>
          </div>

          <div class="notification-content">
            <p class="notification-message">
              {{ messageBeforeLink(notif) }}
              @if (hasLocalizedLink(notif)) {
              <button type="button" class="here-link" (click)="navigateToNotification(notif, $event)">
                {{ translationService.translate('hereText') }}
              </button>
              {{ messageAfterLink(notif) }}
              } @else if (notif.link) {
              <button type="button" class="here-link" (click)="navigateToNotification(notif, $event)">{{ notif.message }}</button>
              }
            </p>
            <div class="notification-footer">
              <span class="notification-time">{{ getRelativeTime(notif.createdAt) }}</span>
              @if (notif.isSeen) {
              <span class="read-indicator">
                <mat-icon class="check-icon">check</mat-icon>{{ translationService.translate('readText') }}
              </span>
              } @else {
              <button type="button" class="mark-read-link" (click)="markAsRead(notif, $event)">
                {{ translationService.translate('markAsReadText') }}
              </button>
              }
            </div>
          </div>

          <button type="button" class="item-menu-button" [matMenuTriggerFor]="itemMenu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #itemMenu="matMenu">
            @if (!notif.isSeen) {
            <button mat-menu-item (click)="markAsRead(notif)">
              <mat-icon>done</mat-icon>
              <span>{{ translationService.translate('markAsReadText') }}</span>
            </button>
            } @if (notif.link) {
            <button mat-menu-item (click)="navigateToNotification(notif)">
              <mat-icon>open_in_new</mat-icon>
              <span>{{ translationService.translate('viewText') }}</span>
            </button>
            }
          </mat-menu>
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <p>{{ translationService.translate('noNotificationsEmptyStateText') }}</p>
      </div>
      }
    </div>

    <div class="panel-footer">
      <div class="progress-indicator"></div>
    </div>
  </div>
  }
</div>
}
